export function add() {
    console.log(1);
}